
export const faq = [
    {
        issue: 'faq.issue.item1.issue',
        reply: 'faq.issue.item1.reply',
        selected : false,
        link: ''
    },
    {
        issue: 'faq.issue.item2.issue',
        reply: 'faq.issue.item2.reply',
        selected : false,
        link:'https://support.kinomap.com/hc/fr/articles/360038226271-Comment-utiliser-la-fonction-d-affichage-WEB-'
    },
    {
        issue: 'faq.issue.item3.issue',
        reply: 'faq.issue.item3.reply',
        selected : false,
        link:'https://support.kinomap.com/hc/fr/articles/210554366-Comment-utiliser-le-capteur-optique-'
    },
    {
        issue: 'faq.issue.item4.issue',
        reply: 'faq.issue.item4.reply',
        selected : false,
        link:'https://support.kinomap.com/hc/fr/articles/217526666-Comment-est-calcul%C3%A9e-la-vitesse-dans-nos-applications-d-entra%C3%AEnement-'
    },
    {
        issue: 'faq.issue.item5.issue',
        reply: 'faq.issue.item5.reply',
        selected : false,
        link:''
    },

  ];



